import TechicalIssues from "src/components/TechnicalIssues/TechicalIssues";

const technicalIssues = () => {
  return <TechicalIssues />;
};

export default technicalIssues;
